
        import V from 'voUtils/V.js';
        import Vue from 'vue';
        import {voMsg,voMsgPl} from './voUtils/voI18n.js';
        import DateEx from './voUtils/DateEx.js';

        Vue.prototype.VOFFICE = window.VOFFICE;

        var voFormatDate = DateEx.formatDate;

        import AirbnbStyleDatepicker from 'base/vue-airbnb-style-datepicker'
        import 'base/vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

        var vueApps = {};

        var methods = {voMsg,voMsgPl,voFormatDate};

        
            import App0 from './app/search.js';
            vueApps['app/search.js'] = App0;
        

            import App1 from './app/navbar.js';
            vueApps['app/navbar.js'] = App1;
        

            import App2 from './app/dummy.js';
            vueApps['app/dummy.js'] = App2;
        

            import App3 from './app/unit.js';
            vueApps['app/unit.js'] = App3;
        

            import App4 from './app/AlleDomizile.js';
            vueApps['app/AlleDomizile.js'] = App4;
        

            import App5 from './app/PremiumDomizile.js';
            vueApps['app/PremiumDomizile.js'] = App5;
        

            import App6 from './app/KomfortDomizile.js';
            vueApps['app/KomfortDomizile.js'] = App6;
        

            import App7 from './app/KlassikDomizile.js';
            vueApps['app/KlassikDomizile.js'] = App7;
        

            import App8 from './app/Dahme.js';
            vueApps['app/Dahme.js'] = App8;
        

            import App9 from './app/Kellenhusen.js';
            vueApps['app/Kellenhusen.js'] = App9;
        

            import App10 from './app/Gromitz.js';
            vueApps['app/Gromitz.js'] = App10;
        

            import App11 from './app/Timmendorf.js';
            vueApps['app/Timmendorf.js'] = App11;
        

            import App12 from './app/Ferienhauser.js';
            vueApps['app/Ferienhauser.js'] = App12;
        

            import App13 from './app/spontane.js';
            vueApps['app/spontane.js'] = App13;
        

            import App14 from './app/Ferienwohnungen.js';
            vueApps['app/Ferienwohnungen.js'] = App14;
        

            import App15 from './app/Sussau.js';
            vueApps['app/Sussau.js'] = App15;
        

        
                import Comp16 from './comp/PopupBox.vue';
                Vue.component('voffice-popup-box',Comp16);
            

                import Comp17 from './comp/DateRange.vue';
                Vue.component('voffice-daterange',Comp17);
            

                import Comp18 from './comp/GuestBox.vue';
                Vue.component('voffice-guestbox',Comp18);
            

                import Comp19 from './comp/Paginate.vue';
                Vue.component('voffice-paginate',Comp19);
            

                import Comp20 from './comp/SearchFilterTokens.vue';
                Vue.component('search-filter-tokens',Comp20);
            

                import Comp21 from './comp/RatingDisplay.vue';
                Vue.component('rating-display',Comp21);
            

                import Comp22 from './comp/SearchImageCarousel.vue';
                Vue.component('img-carousel',Comp22);
            

                import Comp23 from './comp/MailLink.vue';
                Vue.component('mail-link',Comp23);
            

                import Comp24 from './comp/FavElement.vue';
                Vue.component('voffice-fav-element',Comp24);
            

                import Comp25 from './comp/ErrorMessage.vue';
                Vue.component('voffice-error-message',Comp25);
            

                import Comp26 from './comp/ContactForm.js';
                Vue.component('voffice-form',Comp26);
            

                import Comp27 from './comp/DocBox.vue';
                Vue.component('voffice-doc-box',Comp27);
            

                import Comp28 from './comp/ImgFallback.vue';
                Vue.component('img-fallback',Comp28);
            

                import Comp29 from './comp/PhotoSwipe.js';
                Vue.component('voffice-photoswipe',Comp29);
            

                import Comp30 from './comp/MaxTextSize.js';
                Vue.component('voffice-max-text-size',Comp30);
            

                import Comp31 from './comp/gmap.js';
                Vue.component('voffice-gmap',Comp31);
            

                import Comp32 from './comp/openstreetmap.vue';
                Vue.component('voffice-openstreetmap',Comp32);
            

                import Comp33 from './comp/ScrollToDiv.vue';
                Vue.component('scroll-to-div',Comp33);
            

                import Comp34 from './comp/CookieBox.vue';
                Vue.component('voffice-cookie-box',Comp34);
            

                import Comp35 from './comp/stardisplay.vue';
                Vue.component('star-display',Comp35);
            

                import Comp36 from './comp/Booking.js';
                Vue.component('voffice-booking',Comp36);
            

                import Comp37 from './comp/Voucher.vue';
                Vue.component('voffice-voucher',Comp37);
            

        Vue.mixin({
            methods: methods
        });

        const datepickerOptions = {
            days: voMsg('weekdayslist').split(','),
            daysShort: voMsg('weekdayslist.short').split(','),
            monthNames: voMsg('monthlist.full').split(',')
        };
        Vue.use(AirbnbStyleDatepicker, datepickerOptions);


    	var passThrough = function (val) {
			return val || '';
		};

    	var filterCodes = [
    	    'vlang',
    	    'vautolang',
    	    'vsoption',
    	    'vsPropOption'
    	  ];

        for (let fc of filterCodes) {
    		Vue.filter(fc, passThrough);
    	};


        var vueAppEls = document.body.querySelectorAll('[vo-vue-app]');

        for (let el of vueAppEls) {
            let vName = el.getAttribute("vo-vue-app");
            let v = vueApps[vName];
            if (v) {
                v.el = el;
                V.log("creating vue app",vName);

                let app = new Vue(v);
            }

        }

        VOFFICE.afterAllLoaded = function(){
            document.documentElement.classList.add("app-loaded");
        };

        window.addEventListener('beforeunload', function (event) {
        	document.documentElement.classList.add("app-leaving");
        });


    